import Vue from "vue";

import { generateNumerologyPdf, generateNumerologyMandala } from "@/common/functions";

import { GENERATE_NUMEROLOGY_PDF, GENERATE_NUMEROLOGY_MANDALA } from "../actions";
import { SET_KEY_NESTED } from "../mutations";

const state = {
  items: {},

  errors: null,
};

const getters = {};

const mutations = {
  [SET_KEY_NESTED](state, { key, id, ...payload }) {
    Vue.set(state[key], id, payload);
  },
};

const actions = {
  async [GENERATE_NUMEROLOGY_PDF]({ commit }, payload) {
    try {
      const { data } = await generateNumerologyPdf({ ...payload });

      commit(SET_KEY_NESTED, { key: "items", ...data });

      return { isSuccess: true, ...data };
    } catch (error) {
      console.log("ERR", error);
      return { isSuccess: false };
    }
  },
  async [GENERATE_NUMEROLOGY_MANDALA]({ commit }, payload) {
    try {
      const { data } = await generateNumerologyMandala({ ...payload });
      console.log("data", data);
      commit(SET_KEY_NESTED, { key: "items", ...data });

      return { isSuccess: true, ...data };
    } catch (error) {
      console.log("ERR", error);
      return { isSuccess: false };
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
